import { init } from './init'
import { sanitizeData, sanitizeExpire } from './Sanitize'

const actionTypes = {
  FETCH_LOGON: 'FETCH_GDPR',
  RESET: 'RESET',
}

const fetchReset = async state => {
  state = {
    ...state,
    isLoading: false,
    isStatus: true,
    expireToken: false,
    data: false,
  }
  return state
}

const fetchLogon = async (state, gdprupdate) => {
  state = {
    ...state,
    isStatus: gdprupdate.status,
    expireToken: sanitizeExpire({
      status: gdprupdate.status,
      data: gdprupdate.data,
      name: 'gdprupdateobj',
    }),
    data: sanitizeData({
      status: gdprupdate.status,
      data: gdprupdate.data,
      name: 'gdprupdateobj',
    }),
  }
  return state
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_GDPR:
      return fetchLogon(state, action.gdprupdate)
    case actionTypes.RESET:
      return fetchReset(state)
    default:
      return state
  }
}

const gdprupdate = {
  init,
  actionTypes,
  reducer,
}

export default gdprupdate
